import { Link, useParams } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Detail = {
  matterId: string;
  drafts: { id: string; templateName: string; state: string }[];
  deadlines: { id: string; formKind: string; deadlineDate: string; status: string }[];
};

export default function MatterDetailPage() {
  const { matterId = "" } = useParams();
  const { t } = useIntl();
  const { data, loading, error } = useFetch<Detail>(
    `/api/v1/tenant/matters/${encodeURIComponent(matterId)}`,
  );
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">
        {t("matter_detail.title").replace("{id}", matterId)}
      </h1>
      <Link
        to={`/admin/matters/${encodeURIComponent(matterId)}/conflict-log`}
        className="mt-2 inline-block text-sm text-brand-700 hover:underline"
      >
        {t("matter_detail.conflict_log")} ›
      </Link>

      <h2 className="mt-6 text-lg font-semibold text-brand-900">{t("matter_detail.drafts")}</h2>
      <DataTable
        rows={data?.drafts ?? null}
        loading={loading}
        error={error}
        empty={t("matter_detail.empty_drafts")}
        columns={[
          { header: t("drafts.col.template"), render: (r) => r.templateName || "—" },
          { header: t("drafts.col.state"), render: (r) => r.state },
        ]}
      />

      <h2 className="mt-6 text-lg font-semibold text-brand-900">{t("matter_detail.deadlines")}</h2>
      <DataTable
        rows={data?.deadlines ?? null}
        loading={loading}
        error={error}
        empty={t("matter_detail.empty_deadlines")}
        columns={[
          { header: t("deadlines.col.form"), render: (r) => r.formKind },
          { header: t("deadlines.col.date"), render: (r) => r.deadlineDate },
          { header: t("deadlines.col.status"), render: (r) => r.status },
        ]}
      />
    </div>
  );
}
